import { Icon, useStyleConfig } from '@chakra-ui/react';
import React from 'react';

import { WLIconProps } from '../icon.props.interface';

const InsuranceCalculatorIcon: React.FC<WLIconProps> = ({
  variant,
  ...rest
}) => {
  const styles = useStyleConfig('Icon', { variant });

  return (
    <Icon viewBox="0 0 56 56" {...rest} __css={styles}>
      <desc>couple with the house</desc>
      <circle className="background" cx="27.9" cy="28" r="27.5" />
      <path
        className="accent"
        d="M23.5 38.4H12.9V24.9l11.5-8.2 1.1.8c1-1.3 2.4-2.2 4.1-2.5l-5.2-3.7-6.1 4.3v-1.9h-5.4v5.8L6.6 24l2.5 3.6 1.6-1.1v11.8h-1v2.2h13.8v-2.1z"
      />
      <path
        className="accent"
        d="M16.2 25.9h5.9v5.9h-5.9zM44.6 32.4c-1.2-1.1-1.7-2.8-1.1-4.3h-3.1c-2.6 0-4.7 1.7-4.7 4.2v6.5c.2.1.4.2.5.3.3-.2.7-.3 1-.3 2.3-.2 3.8-1.5 4.6-4l1.2.4c-.7 2.1-2.2 4.6-5.7 4.9-.1 0-.3 0-.4.1.3.7.3 1.5.2 2.2-.1.3-.2.7-.3 1 .4.2.8.3 1.2.3 7.1-.5 9.4-6.5 9.7-10.5-.3.1-.5.1-.8.1-.7 0-1.6-.3-2.3-.9z"
      />
      <path
        className="accent"
        d="M48.3 27.9c-.5-.6-1.2-1-2-1.1-.3 0-.5.1-.7.3-.2.2-.4.4-.5.7-.8 1.1-.7 2.7.3 3.6.5.4 1.1.6 1.7.6.6 0 1.1-.2 1.5-.5.2-.2.4-.5.6-.8.9-1.3.1-1.9-.9-2.8zM36 42.3c.2-1.1-.2-2.3-1.3-2.4-3.7-.3-5.4-2.9-6.1-5.2l1.2-.4c.8 2.5 2.3 3.9 4.6 4.2v-6.3c0-1.2.4-2.4 1.2-3.4-1-1.2-2.5-1.9-4.1-1.8h-3c-2.8 0-4.9 1.8-4.9 4.5.1 4.1 2.2 11.5 10.4 12.1 1 0 1.8-.4 2-1.3zM41.4 26.9c2.5 0 4.5-2 4.5-4.5s-2-4.5-4.5-4.5C39 18 37 20 37 22.4c0 2.5 2 4.5 4.4 4.5zM30.5 25.9c2.6 0 4.7-2.1 4.7-4.7s-2.1-4.7-4.7-4.7-4.7 2.1-4.7 4.7c-.1 2.5 2 4.7 4.7 4.7zM24.9 40v4h5c-2-.8-3.8-2.2-5-4z"
      />
    </Icon>
  );
};

export default InsuranceCalculatorIcon;
